export default __webpack_public_path__ + "static/media/IQVIALogo-Tricolor.2830f9e4.svg";